import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'k-version-update-dialog',
  templateUrl: './version-update-dialog.component.html',
  imports: [ MatDialogModule, TranslateModule, ButtonComponent ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionUpdateDialogComponent {
  private document = inject(DOCUMENT);
  private swUpdate = inject(SwUpdate);

  onReload(): void {
    sessionStorage.setItem('klubovna_update_reload', Date.now().toString());
    this.swUpdate.activateUpdate()
      .then(() => this.document.location.reload())
      .catch(() => this.document.location.reload());
  }
}
